<script>
    import { preventDefault } from 'svelte/legacy';

import {
    environment
} from '@app/store/envStore.svelte.js'; 
import {
    fade
} from 'svelte/transition';
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    styleState
} from '@app/store/styleStore.svelte.js';
import {authState} from '@app/store/authStore.svelte.js';
import {
    saveAs
} from 'file-saver';
import Swal from 'sweetalert2'
import { SWAL_BASE, SWAL_CLASSES } from '@app/lib/swalClasses.js';
import throttle from 'just-throttle';
import { activateSubscription } from "@app/lib/activateSubscription.js";
import * as m from "@app/paraglide/messages.js";
/* Firebase */
/* CC LIB */
import tcLib from "@cclib/lib/timecode.js";
import incodeTime from "@cclib/lib/incodeTime.js";
import encode from "@cclib/functions/encode.js";
import defaults from "@cclib/lib/defaults.js";
import formats from "@cclib/lib/formats.js";
import orderByTime from "@cclib/functions/eventGroups/orderByTime.js";
import removeHtmlEntities from "@cclib/functions/eventGroups/removeHtmlEntities.js";
import replaceTrialText from "@cclib/functions/eventGroups/replaceTrialText.js";
import wrapStyledTextWithSpan from '@cclib/functions/quill/wrapStyledTextWithSpan.js';
import offset from "@cclib/functions/events/tcOffset.js";
import tcMultiply from "@cclib/functions/special/tcMultiply.js";
import reorderRtlText from "@cclib/functions/utility/reorderRtlText.js";

/* Export Preset Store */
import {
    getPresetsByType,
    getPresetById,
    PRESET_TYPES
} from "@app/store/presetStore.svelte.js";

/* Translate for Creator */
let targetFolder;
let selectedGroups = $state([]), 
    selectedPresetIds = $state(JSON.parse(localStorage.getItem("cc-subtitle-batch-export-preset-ids")) || []),
    availablePresets = $derived(getPresetsByType(PRESET_TYPES.SUBTITLE)),
    isExporting = $state(false),
    exportProgress = $state(0),
    totalExports = $state(0),
    currentExportName = $state("");

// Persist selectedPresetIds to localStorage
$effect(() => {
    localStorage.setItem("cc-subtitle-batch-export-preset-ids", JSON.stringify(selectedPresetIds));
});

if (authState.status === "in_trial"){
    showTrialWarning();
}

function showTrialWarning(){
    Swal.fire({
        ...SWAL_BASE,
        titleText: m.batch_subtitle_export_trial_title(),
        text : m.batch_subtitle_export_trial_text(),
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: m.batch_subtitle_export_activate_account(),
        denyButtonText: m.batch_subtitle_export_continue_trial(),
        allowOutsideClick : false,
        allowEscapeKey : false,
        customClass: SWAL_CLASSES.trial,
    }).then((result) => {
        if (result.isConfirmed) {
            activateSubscription();
        }
    }).catch(err =>{
        console.log(err);
        console.log(err.message)
    });
}

function removeAllFormats(){
    selectedPresetIds = [];
    localStorage.setItem("cc-subtitle-batch-export-preset-ids", JSON.stringify(selectedPresetIds));
}

function updateProfile(index, ext) {
    // No longer needed with preset system
    // Kept for compatibility
}

async function batchExport() {
    if (selectedGroups.length===0 || selectedPresetIds.length === 0){
        toast.push(m.batch_subtitle_export_none_selected(), {classes: ["toast-warning"]});
        return;
    }

    isExporting = true;
    exportProgress = 0;
    totalExports = selectedGroups.length * selectedPresetIds.length;
    let completedExports = 0;

    if (environment.electron) {
        if (!targetFolder){
            targetFolder = await selectTargetFolder();
            if (!targetFolder) {
                isExporting = false;
                return;
            }
        }
    }

    for (let i = 0; i<selectedGroups.length; i++){
        let groupId = selectedGroups[i];
        console.log("--------");
        console.log("GroupID: " +groupId);
        try {
            let eventGroupIndex = eventGroupState.findIndex(evGroup => {
                return groupId === evGroup.id;
            });

            // Iterate through selected presets instead of fileFormats
            for (const presetId of selectedPresetIds) {
                try { 
                    const preset = getPresetById(presetId);
                    if (!preset || !preset.config) continue;
                    
                    const config = preset.config;
                    
                    // Extract all settings from preset
                    const trgExt = config.trgExt;
                    const trgProfile = config.trgProfile;
                    let trgFrameRate = parseFloat(config.trgFrameRate || projectState.frameRate);
                    let trgDropFrame = config.trgDropFrame === "true" ? true : false;
                    
                    // Update progress status
                    currentExportName = `${eventGroupState[eventGroupIndex].name}.${trgExt} (${preset.name})`;
                    
                    // Apply frame rate validation
                    if ([23.976, 24, 25, 30, 50, 60].indexOf(trgFrameRate) > -1){
                        trgDropFrame = false;
                    }
                    
                    // Get other settings from preset
                    const tcOffset = config.tcOffset || "00:00:00:00";
                    const tcOffsetType = config.tcOffsetType || "add";
                    const tcMultiplier = config.tcMultiplier || 1;
                    const fileEncoding = config.fileEncoding || defaults.encoding;
                    const fns = config.fns || "include";
                    const reverseRtlStartEndOption = config.reverseRtlStartEndOption || false;
                    const useClockTime = config.useClockTime || 'yes';
                    
                    let trgIncode = config.trgIncode ||"00:00:00:00";
                    // Validate timecodes with preset's frame rate
                    trgIncode = tcLib.tcValidate(trgIncode, trgFrameRate, trgDropFrame);
                    const validatedTcOffset = tcLib.tcValidate(tcOffset, trgFrameRate, trgDropFrame);
                    
                    console.log("Export Format: " + trgProfile);
                    
                    let fileName = eventGroupState[eventGroupIndex].name + "." + trgExt;
                    let copyOfEventGroup = JSON.parse(JSON.stringify(eventGroupState[eventGroupIndex]));
                    
                    /* FS Filtering START */
                    if (fns === "exclude") {
                        copyOfEventGroup.events = copyOfEventGroup.events.filter((event) => {
                            return !event.flags || event.flags.indexOf("FS") === -1;
                        });
                    } else if (fns === "only") {
                        copyOfEventGroup.events = copyOfEventGroup.events.filter((event) => {
                            return event.flags && event.flags.indexOf("FS") > -1;
                        });
                    }
                    /* FS Filtering END */
                    
                    /* RTL Formatting */
                    if (reverseRtlStartEndOption) {
                        copyOfEventGroup = reorderRtlText(copyOfEventGroup);
                    }
                    /* RTL Formatting END */
                    
                    copyOfEventGroup = orderByTime(copyOfEventGroup);
                    copyOfEventGroup = removeHtmlEntities(copyOfEventGroup);
                    let defaultEncoding = formats.defaultEncodingMap[formats.profileMapping[trgProfile].name];

                    /* Incode Math */
                    let incode = trgIncode;

                    if (useClockTime === "no"){
                        incode = incodeTime.remapIncodeForNonClockPipeline(trgIncode, trgFrameRate, trgDropFrame);
                    }
                    /* Incode Math End */

                    /* tcOffset */
                    if (validatedTcOffset && validatedTcOffset !== "00:00:00:00") {
                        let tcOffsetSec = tcLib.tcToSec(validatedTcOffset, trgFrameRate, trgDropFrame);
                        if (
                            tcOffsetType === "add" ||
                            (tcOffsetType === "subtract" &&
                                copyOfEventGroup.events.length > 0 &&
                                tcOffsetSec < copyOfEventGroup.events[0].start)
                        ) {
                            copyOfEventGroup.events.forEach((event, index, events) => {
                                events[index] = offset(
                                    event,
                                    tcOffsetSec,
                                    tcOffsetType,
                                );
                            });
                        }
                    }

                    if (tcMultiplier && tcMultiplier != 0 && tcMultiplier != 1) {
                        copyOfEventGroup = tcMultiply(copyOfEventGroup, tcMultiplier);
                    }

                    let options = new defaults.options({
                        profile: formats.profileMapping[trgProfile].name,
                        formatOptions: formats.profileMapping[trgProfile].options.encode,
                        frameRate: trgFrameRate,
                        dropFrame: trgDropFrame,
                        incode : incode || "00:00:00:00",
                        target_profile : formats.profileMapping[trgProfile].name,
                        source_profile : 'closedCaptionProject',
                        window: {
                            width: styleState.width,
                            height: styleState.height,
                            xPadding: styleState.xPadding,
                            yPadding: styleState.yPadding
                        }
                    });                    

                    if (authState.status === "in_trial"){
                        copyOfEventGroup = replaceTrialText(copyOfEventGroup);
                    }

                    copyOfEventGroup.events.forEach((event, index, events) =>{
                        events[index].text = wrapStyledTextWithSpan(event.text);
                    });

                    let output = await encode(copyOfEventGroup, options);
                    let fileBlob;
                    
                    if (defaultEncoding === "buffer"){
                        fileBlob = output instanceof Blob
                            ? output
                            : new Blob([output], {
                                type: "application/octet-stream"
                            });
                    } else if (defaultEncoding.toLowerCase() === "hex") {
                        let byteArray = new Uint8Array(output.match(/.{2}/g).map(e => parseInt(e, 16)));
                        fileBlob = new Blob([byteArray], {
                            type: "application/octet-stream"
                        });
                    } else if (defaultEncoding.toLowerCase() === "utf-16le") {
                        fileBlob = new Blob([output], {
                            type: "text/plain;charset=utf-16le"
                        });
                    } else {
                        fileBlob = new Blob([output], {
                            type: "text/plain;charset=utf-8"
                        });
                    }

                    if (environment.electron) {
                        if (!targetFolder){
                            throw new Error(m.batch_subtitle_export_no_target_folder());
                        }

                        let fs = window.fs;
                        let path = window.path;
                        let filePath = path.join(targetFolder, fileName);
                        // ----
                        let fileArrayBuffer = await fileBlob.arrayBuffer();
                        const fileBuffer = Buffer.from(fileArrayBuffer);
                        await fs.writeFile(filePath, fileBuffer);
                    } else {
                        saveAs(fileBlob, fileName, {
                            autoBom: true
                        });
                    }
                    
                    // Update progress
                    completedExports++;
                    exportProgress = Math.round((completedExports / totalExports) * 100);
                                                          
                } catch(err){
                    console.log(err, err.message);
                    toast.push(m.batch_subtitle_export_failed_single(), {classes: ["toast-warning"]});
                    
                    // Still update progress even on error
                    completedExports++;
                    exportProgress = Math.round((completedExports / totalExports) * 100);
                }   
            }
        } catch(err){
            console.log(err, err.message);
            toast.push(m.batch_subtitle_export_failed_single(), {classes: ["toast-warning"]});
        }
        
    };

    isExporting = false;
    toast.push(m.batch_subtitle_export_completed_successfully(), {classes: ["toast-success"]});
    hideModal();
}

function selectTargetFolder() {
    return ipcRenderer
        .invoke("selectFolder", {
            title: m.batch_subtitle_export_select_folder_title(),
            properties: ["openDirectory", "createDirectory"],
        })
        .then((path) => {
            if (!path.canceled) {
                console.log(path.filePaths[0]);
                return path.filePaths[0];
            } else {
                return false;
            }
        });
}
</script>

<div 
    transition:fade={{duration: 100}} 
    class="modal {modalState.selected === 'batchSubtitleExport' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="batchExportTitle"
    aria-describedby="batchExportDescription"
    tabindex="-1" 
    id="BatchSubtitleExportModal">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="batchExportTitle">{m.batch_subtitle_export_title()}</h4>
                <button type="button" 
                    class="btn-close" 
                    aria-label={m.batch_subtitle_export_close_label()} 
                    id="closeBatchExportBtn"
                    disabled={isExporting}
                    onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <form onsubmit={preventDefault(batchExport)} id="batchExportForm" aria-describedby="batchExportDescription">
                    <div id="batchExportDescription" class="visually-hidden">
                        {m.batch_subtitle_export_description()}
                    </div>
                    
                    <!-- Event Groups -->
                    <div class="mb-3">
                        <label class="form-label" for="eventGroupSelect">{m.batch_subtitle_export_event_groups_label()}</label>
                        <select 
                            multiple 
                            size="10" 
                            class="form-control" 
                            id="eventGroupSelect"
                            aria-required="true"
                            aria-label={m.batch_subtitle_export_event_groups_aria()}
                            bind:value={selectedGroups}>
                            {#each eventGroupState as eventGroup (eventGroup.id)}
                                <option value={eventGroup.id}>{eventGroup.name}</option>
                            {/each}
                        </select>
                    </div>
                    <!-- Export Presets -->
                    <div class="mb-3">
                        <label class="form-label" for="presetSelection">{m.batch_subtitle_export_presets_label()}</label>
                        {#if availablePresets.length === 0}
                            <div class="text-center text-muted py-4 border rounded">
                                <p class="mb-0">{m.batch_subtitle_export_no_presets()}</p>
                            </div>
                        {:else}
                            <select 
                                multiple 
                                size="10" 
                                class="form-control preset-multiselect" 
                                id="presetSelection"
                                aria-required="true"
                                aria-label={m.batch_subtitle_export_presets_aria()}
                                bind:value={selectedPresetIds}>
                                {#each availablePresets as preset (preset.id)}
                                    <option value={preset.id}>
                                        {preset.name} - {preset.config.trgProfile} ({preset.config.trgExt})
                                    </option>
                                {/each}
                            </select>
                            <button type="button" 
                                class="btn btn-sm btn-outline-danger mt-2" 
                                id="resetPresetsBtn"
                                aria-label={m.batch_subtitle_export_clear_presets_aria()}
                                onclick={() => removeAllFormats()}>
                                {m.batch_subtitle_export_clear_selection()}
                            </button>
                        {/if}
                    </div>
                </form>
            </div>
            
            <!-- Progress Bar Section -->
            {#if isExporting}
                <div class="px-4 pb-3">
                    <div class="mb-2">
                        <small class="text-muted">
                            {m.batch_subtitle_export_exporting_label()} <strong>{currentExportName}</strong>
                        </small>
                    </div>
                    <div class="progress" style="height: 25px;">
                        <div 
                            class="progress-bar progress-bar-striped progress-bar-animated" 
                            role="progressbar" 
                            aria-valuenow={exportProgress} 
                            aria-valuemin="0" 
                            aria-valuemax="100" 
                            style="width: {exportProgress}%">
                            {exportProgress}%
                        </div>
                    </div>
                </div>
            {/if}
            
            <div class="modal-footer">
                <button 
                    class="btn btn-primary" 
                    type="submit"
                    form="batchExportForm"
                    id="exportBtn"
                    aria-label={m.batch_subtitle_export_start_aria()}
                    disabled={selectedGroups.length===0 || selectedPresetIds.length === 0 || isExporting} >
                    {#if isExporting}
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {m.batch_subtitle_export_exporting_button()}
                    {:else}
                        {m.batch_subtitle_export_export_button()}
                    {/if}
                </button>
            </div>
        </div>
    </div>
</div>

<style>
    .preset-multiselect {
        max-height: 250px;
        overflow-y: auto;
        font-size: 0.95rem;
    }
    
    .preset-multiselect option {
        padding: 0.5rem;
    }
    
    .progress {
        background-color: #e9ecef;
        border-radius: 0.25rem;
        overflow: hidden;
    }
    
    .progress-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        transition: width 0.3s ease;
        background-color: #0d6efd;
    }
</style>
